import { gql } from '@apollo/client';

export const CORE_TALENT_FIELDS = gql`
  fragment CoreTalentFields on Talent {
    _id
    pdfUrl
    # pdfContent
    pdfStatus
    # totalExperience
    # products
    # dealSize { from to }
    # contractCycle
    # businesses
    # skills
    # engagement
    # startTime
    # endTime
    # level
    # achievements
    linkedin
    # facebook
    # twitter
    # instagram
    # remote
    # education {
    #   school
    #   degree
    #   endYear
    # }
    # workExperience {
    #   company
    #   position
    #   description
    #   startMonth
    #   startYear
    #   endMonth
    #   endYear
    #   isCurrent
    # }
    # state
    # allowPublish
    createdAt
    updatedAt
    applications {
      _id
      isRejected
      job{
        _id
        title
        hideClientName
        questions
      }
      client {
        _id
        company
      }
      questionnaire {
        _id
        passed
      }
      interview {
        _id
        isFinished
        durations
        recording {
          _id
          state
        }
      }
    }
  }
`;
